export default __webpack_public_path__ + "static/media/charles-dashboard.76eeb8dc.png";